<template>
    <span v-if="account.plan_id == 1" class="d-block mt-5 text-center" style="font-size: 12px; line-height: 2;">
        Collaboration is not available on the free plan.
        <router-link :to="{ name: 'account.billing.changePlan' }"
                     style="text-decoration: underline; color: inherit;"
        >Upgrade</router-link> unlock collaboration features.
    </span>

    <div v-else class="color-gray">
        <span class="dashboard-column-title d-block mb-4">Email address</span>

        <v-text-field
            v-for="(guest, index) in form.guests" :key="index"
            :ref="`inputInvitee${index}`"
            v-model="form.guests[index].email"
            :error-messages="form.$errors[`guests.${index}.email`]"
            class="d-flex mb-1"
            dark
            label="Email address"
            outlined
            type="email"
            @blur="form.validate(`guests.${index}.email`)"
            @input="delete form.$errors[`guests.${index}.email`]; formTouched = true;"
            @keyup.enter="addLine"
        />

        <v-row class="mb-10 d-flex justify-content-between">
            <v-btn
                :ripple="false"
                class="btn-def bg-transparent"
                color="#181818"
                dark
                depressed
                rounded
                @click="addLine"
            >
                + Add line
            </v-btn>
            <v-btn
                :ripple="false"
                class="btn-def bg-transparent"
                color="#181818"
                dark
                depressed
                rounded
                @click="removeLine"
            >
                Remove line -
            </v-btn>
        </v-row>

        <v-row v-if="formTouched" class="center">
            <v-col>
                <v-btn :loading="sendLoading" block class="dashboard-button bg-primary color-white" depressed
                       large
                       @click="submitInvitations"
                >
                    <span v-if="!sendSubmitted" class="color-white">Send Invitations</span>
                    <v-icon v-else color="white" medium>mdi mdi-check-circle</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import * as rules from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
    name: "AddGuests",

	props: {
		project: {
			type: Object,
			default: () => {
				return {
					id: null,
				}
			}
		},
	},

    data() {
        return {
            guestRoleId: 7,
            sendLoading: false,
            sendSubmitted: false,
            formTouched: false,
            form: new Form(this, "form", {
                guests: [],
            }),
        };
    },

    validations: {
        form: {
            guests: {
                $each: {
                    email: { email: rules.email, required: rules.required },
                },
            },
        },
    },

    created() {
        this.resetForm();
    },

    computed: {
        ...mapState("Organizations", ["pendingUsers"]),
        ...mapState("User", ["account"]),
        placeholderGuest() {
            return {
                email: null,
                role_id: this.guestRoleId,
            }
        }
    },

    methods: {
        addLine() {
            this.form.guests.push({ ...this.placeholderGuest });

            this.$nextTick(() => {
                this.$refs[`inputInvitee${this.form.guests.length - 1}`][0].focus();
            });
        },

        removeLine() {
            if (this.form.guests.length > 1) {
                this.form.guests.splice(-1, 1);
            }
        },

        resetForm() {
            this.formTouched = false;
            this.form.guests = [{ ...this.placeholderGuest }];
        },

        async submitInvitations() {
            // checking if double emails in form or email alraedy invited
            let filteredList = {
                users: [],
            };

            this.form.guests.forEach(guest => {
                if (!filteredList.users.map(e => e.email).includes(guest.email)) {
                    if (!this.pendingUsers.map(e => e.email).includes(guest.email)) {
                        filteredList.users.push(guest);
                    }
                }
            });

            if (filteredList.users.length == 0) {
                this.resetForm();
                return;
            }

			if (this.project.id) {
				filteredList.project_id = this.project.id;
			}

            this.sendLoading = true;

            await this.$store.dispatch('Organizations/inviteUsers', filteredList);
            await this.$store.dispatch("Organizations/fetchPendingUsers");

            this.sendLoading = false;
            this.sendSubmitted = true;

            setTimeout(() => {
                this.sendSubmitted = false;
            }, 3000);

            this.resetForm();
        }
    }
}
</script>